import React from 'react';
import { HiChartBar, HiPlay, HiDocumentText, HiCog} from 'react-icons/hi';

const icons = {
  HiChartBar,
  HiDocumentText,
  HiCog,
  HiPlay,
};

const IconComponent = ({ iconName }) => {


  const Icon = icons[iconName]; // Busca el icono dinámicamente
  return <Icon className="mr-3 h-4 w-4" />;
};

export default IconComponent;